import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RouteGuardHelper } from '@helpers/route.guard.helper';
import { RegisterSuccessComponent } from '@components/register-success.component';
import { environment } from '@environments/environment';
import { LoginBaseModule } from '@sharedTemplates/login/login.base.module';
import { SporMobileMenu } from './components/spor-mobile-menu';

let AppRoute: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'home', loadChildren: () => import('@app/sharedTemplates/home/home.base.module').then(m => m.HomeBaseModule) },
  { path: 'account', loadChildren: () => import('@app/components/account/account.module').then(m => m.AccountModule), canActivate: [RouteGuardHelper] },
  { path: 'sports', loadChildren: () => import('@app/components/sports/SportsPage.module').then(m => m.SportsPageModule) },
  { path: 'search', loadChildren: () => import('@components/sports/SearchPage.module').then(m => m.SearchPageModule) },
  { path: 'searchmatch', loadChildren: () => import('@components/sports/SearchMatchPage.module').then(m => m.SearchMatchPageModule) },
  { path: 'slipdetail', loadChildren: () => import('@components/slipDetails/SlipDetailsPage.module').then(m => m.SearchMatchPageModule), canActivate: [RouteGuardHelper] },
  { path: 'eventdetail', loadChildren: () => import('@components/eventDetails/EventDetailsPage.module').then(m => m.EventDetailsPageModule) },
  { path: 'live', loadChildren: () => import('@components/fixture/live/LivePage.module').then(m => m.LivePageModule) },
  { path: 'liveeventdetail', loadChildren: () => import('@components/eventDetails/LiveEventDetailsPage.module').then(m => m.LiveEventDetailsPageModule) },
  { path: 'livefixtureview', loadChildren: () => import('@components/fixture/live/LivePage.module').then(m => m.LivePageModule) },
  { path: 'outrightsports', loadChildren: () => import('@app/components/outright/OutrightSportsPage.module').then(m => m.OutrightSportsPageModule) },
  {
    path: 'ticketdetail',
    loadChildren: () => import('@app/components/ticketDetails/TicketDetailsPage.module').then(m => m.TicketDetailsPageModule),
    canActivate: [RouteGuardHelper],
  },
  { path: 'spor', component: SporMobileMenu },

  { path: 'page', loadChildren: () => import('./components/staticPage/PageRoute.module').then(m => m.PageRouteModule) },
  { path: 'registersuccess', component: RegisterSuccessComponent, canActivate: [RouteGuardHelper] },
  { path: 'popular', loadChildren: () => import('./components/sports/PopularPage.module').then(m => m.PopularPageModule) },
  { path: 'highlights', loadChildren: () => import('./components/sports/HighlightsPage.module').then(m => m.HighlightsPageModule) },
  { path: 'lastminute', loadChildren: () => import('./components/sports/LastMinutePage.module').then(m => m.LastMinutePageModule) },
  { path: 'league', loadChildren: () => import('./components/sports/LeaguePage.module').then(m => m.LeaguePageModule) },
  { path: 'scanner', loadChildren: () => import('./components/scanner/scanner.module').then(m => m.ScannerModule) },
  { path: 'promotions', loadChildren: () => import('./components/promotion/promotion.module').then(m => m.PromotionModule) },
  { path: 'article', loadChildren: () => import('./components/staticPage/ArticlePage.module').then(m => m.ArticlePageModule) },
  { path: 'banner', loadChildren: () => import('./components/staticPage/BannerPage.module').then(m => m.BannerPageModule) },
  { path: 'favorites', loadChildren: () => import('@components/fixture/favorites/favorites.module').then(m => m.FavoritesModule), canActivate: [RouteGuardHelper] },
  { path: 'mybets', loadChildren: () => import('@app/components/cashout/CashoutPage.module').then(m => m.CashoutPageModule) },
  { path: 'allsports', loadChildren: () => import('@app/components/allSports/AllSportsPage.module').then(m => m.AllSportsPageModule) },
  { path: 'outright', loadChildren: () => import('@app/components/outright/OutrightPage.module').then(m => m.OutrightPageModule) },
  { path: 'allevents', loadChildren: () => import('@app/components/sports/AllEventsPage.module').then(m => m.AllEventsPageModule) },
  { path: 'mailconfirm', loadChildren: () => import('./components/mailConfirm/MailConfirm.module').then(m => m.MailConfirmModule) },
  { path: 'document', loadChildren: () => import('./components/documentUpload/DocumentUpload.module').then(m => m.DocumentUploadModule), canActivate: [RouteGuardHelper] },
  { path: 'recoverpassword', loadChildren: () => import('./components/recoverPassword/RecoverPassword.module').then(m => m.RecoverPasswordModule) },
  { path: 'reserve', loadChildren: () => import('./components/bookBets/book-bets.module').then(m => m.BookBetsModule) },
];

const casinoRoutes: Routes = [{ path: 'casino', loadChildren: () => import('./components/casino/casino.module').then(m => m.CasinoModule) }];

const p1012AppRoutes: Routes = [{ path: 'login', component: LoginBaseModule, canActivate: [RouteGuardHelper] }];

if (environment.product === 'p1012') {
  AppRoute = [...AppRoute, ...p1012AppRoutes, ...casinoRoutes];
}

//  canActivate: [RouteGuardHelper]
// todo Using default route loaded method. Must to try preload?

@NgModule({
  imports: [
    RouterModule.forRoot(AppRoute, {
      scrollPositionRestoration: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class MobileRouting {}
// export const MobileRouting: ModuleWithProviders = RouterModule.forRoot(MobileAppRoutes, { enableTracing: true });
